import clsx from 'clsx';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Avatar from '../../../base/avatar/components/Avatar';
import ChatMessage from './ChatMessage';
const useStyles = makeStyles()(theme => {
    return {
        messageGroup: {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '100%',
            gap: '4px',
            '&.remote, &.file': {
                maxWidth: 'calc(100% - 40px)',
                alignItems: 'flex-start'
            },
            '&.local': {
                alignItems: 'flex-end',
                textAlign: 'right'
            }
        },
        groupContainer: {
            display: 'flex',
            marginBottom: '16px',
            width: '100%',
            alignItems: 'flex-end',
            '&.local': {
                flexDirection: 'row-reverse',
                justifyContent: 'flex-start',
                '& .avatar': {
                    display: 'none'
                }
            }
        },
        avatar: {
            margin: `auto ${theme.spacing(1)} 0 0`,
            flexShrink: 0,
            alignSelf: 'flex-end',
            marginBottom: '8px'
        }
    };
});
const ChatMessageGroup = ({ className = '', messages }) => {
    const { classes, cx } = useStyles();
    const messagesLength = messages.length;
    if (!messagesLength) {
        return null;
    }
    const isAssistant = messages[0]?.displayName === 'Meeting Assistant';
    return (React.createElement("div", { className: clsx(classes.groupContainer, className, isAssistant && 'assistant'), style: isAssistant ? { justifyContent: 'center', marginBottom: '24px' } : {} },
        !isAssistant && (React.createElement("div", { className: cx(classes.avatar, 'avatar-container'), style: { alignSelf: 'flex-end', display: 'flex' } },
            React.createElement(Avatar, { participantId: messages[0].participantId, size: 32, url: messages[0]?.displayName === 'Snwolley AI' ? 'images/snwolley.png' : undefined }))),
        React.createElement("div", { className: `${classes.messageGroup} chat-message-group ${className}`, style: isAssistant ? { maxWidth: '100%', alignItems: 'center' } : {} }, messages.map((message, i) => (React.createElement(ChatMessage, { className: className, key: i, message: message, showDisplayName: i === 0, showTimestamp: i === messages.length - 1 }))))));
};
export default ChatMessageGroup;
